import { ComponentsOverrides, Theme } from "@mui/material";
import { ciCustomColors } from "@/theme/colors";

type MuiTableCellType = {
  styleOverrides: ComponentsOverrides<Theme>["MuiTableCell"];
};

const MuiTableCell: MuiTableCellType = {
  styleOverrides: {
    root: {
      borderBottom: `2px solid ${ciCustomColors.blue[50]}`,
    },
  },
};

export { MuiTableCell };
